/* Variant, gallery and add-to-cart behavior for the native Shopify product form. */
(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.sfBound || !window.SAM) return;
    const api = window.SAM, form = root.querySelector('.sf-product-form'), native = root.querySelector('[data-variant-select]');
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-product-variants]').textContent); } catch (_) { return; }
    if (!form || !native || !variants?.length || variants.length !== native.options.length) return;
    root.dataset.sfBound = 'true';
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const add = root.querySelector('[data-product-add]'), label = root.querySelector('[data-add-label]'), status = root.querySelector('[data-product-status]');
    const price = root.querySelector('[data-product-price]'), compare = root.querySelector('[data-product-compare]'), qty = root.querySelector('[data-product-quantity]');
    const mobile = root.querySelector('[data-mobile-buy]'), mobileAdd = root.querySelector('[data-mobile-add]'), mobileLabel = root.querySelector('[data-mobile-label]');
    const originalLabel = label.textContent.trim() === 'AGOTADO' ? 'AÑADIR A LA BOLSA' : label.textContent.trim();
    const media = [...root.querySelectorAll('[data-media-id]')], thumbs = [...root.querySelectorAll('[data-thumb-media]')];
    let activeIndex = Math.max(0, media.findIndex(el => el.classList.contains('is-active')));
    let current = variants.find(v => String(v.id) === native.value) || variants[0], busy = false;
    const selected = () => groups.map(group => group.querySelector('[aria-pressed=true]')?.dataset.optionValue || '');
    const stage = root.querySelector('[data-gallery-stage]');
    let mediaSwitchTimer;
    const selectMedia = id => {
      const index = media.findIndex(el => String(el.dataset.mediaId) === String(id));
      if (index < 0 || index === activeIndex) return;
      const previousIndex = activeIndex;
      const direction = index > previousIndex ? 'next' : 'prev';
      activeIndex = index;
      if (stage) {
        stage.dataset.galleryDirection = direction;
        stage.style.setProperty('--sf-gallery-glow-x', direction === 'next' ? '18px' : '-18px');
        stage.style.setProperty('--sf-gallery-glow-y', index % 2 ? '-8px' : '8px');
        stage.classList.remove('is-switching');
        void stage.offsetWidth;
        stage.classList.add('is-switching');
        clearTimeout(mediaSwitchTimer);
        mediaSwitchTimer = setTimeout(() => stage.classList.remove('is-switching'), 620);
      }
      media.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-hidden', String(i !== index));
        if (i !== index) el.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(thumb => {
        if (String(thumb.dataset.thumbMedia) === String(id)) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView?.({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
        } else thumb.removeAttribute('aria-current');
      });
      const count = root.querySelector('[data-media-current]');
      if (count) {
        count.animate?.([{ opacity:.35, transform:'translateY(3px)' },{ opacity:1, transform:'translateY(0)' }],{ duration:260, easing:'ease-out' });
        count.textContent = String(index + 1);
      }
    };
    const updateAvailability = options => {
      groups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach(button => {
          const exists = variants.some(v => v.available && v.options[index] === button.dataset.optionValue && v.options.slice(0, index).every((value, i) => value === options[i]));
          button.classList.toggle('is-unavailable', !exists);
          button.setAttribute('aria-label', button.dataset.optionValue + (exists ? '' : ' — no disponible con esta selección'));
        });
        const text = group.querySelector('[data-option-label]'); if (text) text.textContent = options[index];
      });
    };
    const refresh = (changeURL = true) => {
      const options = selected();
      current = groups.length ? variants.find(v => v.options.every((value, index) => value === options[index])) : variants.find(v => String(v.id) === native.value);
      updateAvailability(options);
      native.value = current ? String(current.id) : '';
      add.disabled = busy || !current?.available;
      label.textContent = busy ? 'AÑADIENDO…' : current?.available ? originalLabel === 'AGOTADO' ? 'AÑADIR A LA BOLSA' : originalLabel : current ? 'AGOTADO' : 'ELIGE OTRA COMBINACIÓN';
      mobileAdd.disabled = busy || (Boolean(current) && !current.available);
      mobileLabel.textContent = busy ? 'AÑADIENDO…' : current?.available ? 'AÑADIR A LA BOLSA' : current ? 'AGOTADO' : 'ELEGIR OPCIONES';
      if (current) {
        price.textContent = current.price;
        compare.hidden = !current.compare; compare.textContent = current.compare || '';
        root.querySelector('[data-mobile-price]').textContent = current.price;
        root.querySelector('[data-mobile-options]').textContent = groups.length ? current.title : '';
        qty.min = current.min || 1; qty.step = current.increment || 1;
        if (current.max != null) qty.max = current.max; else qty.removeAttribute('max');
        qty.value = api.quantityValue(qty.value, qty.min, qty.max || null, qty.step);
        if (current.mediaId) selectMedia(current.mediaId);
        status.textContent = current.available ? '' : 'Esta opción está agotada. Prueba otro color o talla.';
      } else {
        price.textContent = 'No disponible'; compare.hidden = true; compare.textContent = '';
        root.querySelector('[data-mobile-price]').textContent = 'Elige otra opción';
        root.querySelector('[data-mobile-options]').textContent = options.join(' / ');
        status.textContent = 'Esta combinación de opciones no existe. Elige otra talla o color.';
      }
      if (changeURL) {
        const url = new URL(window.location.href);
        if (current) url.searchParams.set('variant', current.id); else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
      native.dispatchEvent(new Event('change', { bubbles: true }));
    };
    groups.forEach(group => group.addEventListener('click', event => {
      const button = event.target.closest('[data-option-value]');
      if (!button || busy) return;
      group.querySelectorAll('[data-option-value]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      status.classList.remove('sf-error'); refresh();
    }));
    thumbs.forEach(thumb => thumb.addEventListener('click', event => { event.preventDefault(); selectMedia(thumb.dataset.thumbMedia); }));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectMedia(media[(activeIndex - 1 + media.length) % media.length]?.dataset.mediaId));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectMedia(media[(activeIndex + 1) % media.length]?.dataset.mediaId));
    let startX = null, startY = null;
    stage?.addEventListener('touchstart', event => { if (event.touches.length === 1) { startX = event.touches[0].clientX; startY = event.touches[0].clientY; } }, { passive: true });
    stage?.addEventListener('touchend', event => {
      if (startX === null || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - startX, dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5 && media.length > 1) selectMedia(media[(activeIndex + (dx < 0 ? 1 : -1) + media.length) % media.length].dataset.mediaId);
      startX = null;
    }, { passive: true });

    const size = root.querySelector('[data-size-dialog]'), zoom = root.querySelector('[data-zoom-dialog]');
    if (typeof size?.showModal === 'function') {
      root.classList.add('has-dialog');
      root.querySelector('[data-open-size]')?.addEventListener('click', () => size.showModal());
      root.querySelectorAll('[data-product-zoom]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const img = zoom.querySelector('[data-zoom-image]');
        img.src = link.href; img.alt = link.querySelector('img')?.alt || 'Imagen del producto';
        zoom.showModal();
      }));
      [size, zoom].forEach(dialog => {
        dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      });
    }
    qty.addEventListener('change', () => { qty.value = api.quantityValue(qty.value, qty.min, qty.max || null, qty.step); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !current?.available || !form.reportValidity()) return;
      const data = new FormData(form);
      data.set('id', String(current.id));
      const requestedQuantity = api.quantityValue(qty.value, current.min, current.max, current.increment);
      data.set('quantity', String(requestedQuantity));

      // Shopify 2026 standard storefront event. This keeps app integrations
      // (TikTok, analytics, agents) informed even though QUINCHIA uses AJAX.
      const SE = window.StandardEvents;
      let cartEventDeferred = null;
      if (SE?.CartLinesUpdateEvent) {
        try {
          cartEventDeferred = SE.CartLinesUpdateEvent.createPromise();
          root.dispatchEvent(new SE.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(current.id), quantity: Number(requestedQuantity) }],
            promise: cartEventDeferred.promise,
          }));
        } catch (_) { cartEventDeferred = null; }
      }

      busy = true; status.classList.remove('sf-error'); status.textContent = 'Añadiendo a tu bolsa…';
      add.disabled = true; mobileAdd.disabled = true; label.textContent = 'AÑADIENDO…'; mobileLabel.textContent = 'AÑADIENDO…';
      form.setAttribute('aria-busy', 'true');
      qty.disabled = true;
      form.querySelectorAll('[data-quantity-step]').forEach(button => { button.disabled = true; });
      try {
        await api.request(api.routes.add, { method: 'POST', body: data });
        status.replaceChildren(document.createTextNode('Añadido a tu bolsa. '));
        const link = document.createElement('a'); link.href = api.routes.cart; link.textContent = 'Ver bolsa y finalizar compra'; status.append(link);
        label.textContent = 'AÑADIDO'; mobileLabel.textContent = 'AÑADIDO';
        // Fetch the canonical cart after the add so the standard event can resolve
        // with the exact Shopify cart state.
        try {
          const cart = await api.request(api.routes.cartJSON);
          api.updateCount(cart.item_count);
          if (cartEventDeferred && SE?.CartLinesUpdateEvent?.createCartFromAjaxResponse) {
            cartEventDeferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
            cartEventDeferred = null;
          }
        } catch (_) {
          if (cartEventDeferred) { cartEventDeferred.resolve({ cart: null }); cartEventDeferred = null; }
        }
      } catch (error) {
        if (cartEventDeferred) {
          cartEventDeferred.reject(error);
          cartEventDeferred = null;
          try {
            if (SE?.CartErrorEvent) root.dispatchEvent(new SE.CartErrorEvent({ error: error.message || 'Cart add failed', code: 'SERVICE_UNAVAILABLE' }));
          } catch (_) {}
        }
        status.textContent = error.message || 'No pudimos confirmar la compra. Revisa tu bolsa antes de volver a intentarlo.';
        status.classList.add('sf-error');
        const link = document.createElement('a'); link.href = api.routes.cart; link.textContent = ' Revisar bolsa'; status.append(link);
        label.textContent = originalLabel; mobileLabel.textContent = 'AÑADIR A LA BOLSA';
      } finally {
        busy = false; form.setAttribute('aria-busy', 'false'); qty.disabled = false;
        form.querySelectorAll('[data-quantity-step]').forEach(button => { button.disabled = false; });
        add.disabled = !current?.available; mobileAdd.disabled = !current?.available;
      }
    });
    mobileAdd.addEventListener('click', () => {
      if (!current) root.querySelector('.sf-product-info').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      else if (!busy && current.available) form.requestSubmit(add);
    });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        mobile.classList.toggle('is-visible', show); mobile.setAttribute('aria-hidden', String(!show)); mobile.inert = !show;
      }, { threshold: 0 });
      observer.observe(form);
    }
    root.classList.add('is-enhanced'); refresh(false);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { observer?.disconnect(); size?.close?.(); zoom?.close?.(); } }, { once: true });
  }
  document.querySelectorAll('[data-sf-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-sf-product]').forEach(initialize); });
})();
